module.exports = __webpack_public_path__ + "img/DE03114.a223713d.png";